//graphgl
const endpoint = 'https://sunbeamclothing.co.uk/api/2022-10/graphql.json';
const gl_token = '4b0b6d4bec238559a7232ba5213253b7';
var productsForFilter = [];
function FetchData(query, callback) {

  fetch(endpoint, {
    'async': true,
    'crossDomain': true,
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': gl_token,
      'Content-Type': 'application/graphql',
    },
    body: query
  }).then(res => res.json())
    .then(data => {
      callback(data)
    });

}

function FetchDataWithVariables(queryData, variablesData, callback) {

  fetch(endpoint, {
    'async': true,
    'crossDomain': true,
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': gl_token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query: queryData, variables: variablesData })
  }).then(res => res.json())
    .then(data => {
      callback(data)
    });

}


function _getMetaProducts(ids, callback) {
  FetchData(`query {
    nodes(ids: ${JSON.stringify(ids)}) {
    ...on Product {
      id
            metafields (identifiers: [ 
 {namespace: "accentuate", key: "overlay"} 
]){           
          value
          key
          namespace
    }
  }
}}`, function (_data) {
    callback.apply(_data);
  });
}

// Prevent load spr.js
if (document.getElementsByClassName('template-product').length==0) {
  const insertBeforeElementBackup = Element.prototype.insertBefore
  Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
    return insertBeforeElementBackup.apply(this,args)
  }
}

// Prevent load font awesome from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
  if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
  return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove()

// Resize Function
var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
  if ($(window).width() < 1365) {
    // Filters - Open
    $('.filter-refine').on('click', function () {
      $('.filter').toggleClass('filter--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('.filter-overlay').addClass('filter-overlay--active');
      $('html').addClass('no-scroll');
      return false;
    });

    // Filter - Close
    $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
      $('.filter').removeClass('filter--active');
      $('.filter-overlay').removeClass('filter-overlay--active');
      $('html').removeClass('no-scroll');
      return false;
    });
  }

  // Sort Tablet/Desktop
  if ($(window).width() > 599) {
    $('.filter-sort__title').on('click',function(e) {
      e.preventDefault();
    
      var $this = $(this);
    
      if ($this.next().hasClass('filter-sort__list--active')) {
        $this.next().removeClass('filter-sort__list--active');
        $this.next().slideUp(150);
      } else {
        $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
        $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
        $this.next().toggleClass('filter-sort__list--active');
        $this.next().slideToggle(150);
      }

      if ($this.hasClass('filter-sort__title--active')) {
        $this.removeClass('filter-sort__title--active');
        $this.attr('aria-expanded','false');
      } else {
        $this.attr('aria-expanded','true');
        $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
        $this.toggleClass('filter-sort__title--active');
      }

    });

    $(document).on('click.resize',function (e) {
      if (!$(e.target).is(".filter-sort *")) {
        $('.filter-sort__list').removeClass('filter-sort__list--active');
        $('.filter-sort__title').removeClass('filter-sort__title--active');
        $('.filter-sort__list').slideUp(150);
      }
    }); 
  }

  // Sort Mobile
  if ($(window).width() < 600) {
    $('.filter-sort').on('click', function () {    
      $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
      $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('html').toggleClass('no-scroll');
      return false;
    });
    $(document).on('click.resize',function (e) {
      if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
        $('.filter-sort__list').removeClass('filter-sort__list--active');
        $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
        $('html').removeClass('no-scroll');
        
      }
    }); 
  }

  // Header Scroll
  previousScroll = 0;
  headerOrgOffset = 0;
  if ($(window).width() > 1365) {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
  } else {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
  }
  
};

// Filters All
$(document).ready(function() {

 _initFilter();

  $(document).off('click').on('click',function(e) {
    if (!$(e.target).is(".filter__group *")) {
      $('.filter__list').removeClass('filter__list--active');
      $('.filter__title').removeClass('filter__title--active');
      $('.filter__list').slideUp(150);
    }
  });
});

function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
      
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.parent().parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
      $this.attr('aria-expanded','false');
    } else {
      $this.addClass('filter__title--active');
      $this.attr('aria-expanded','true');
    }

  });
}

// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){

    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Set Cookie
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

// Get Cookie
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle').click(function () {
    $('.header-search__form').toggleClass('header-search__form--visible');
    $('.site-container').toggleClass('site-container--blackout');
    $('.header-search__input').focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
    }
  });
});       

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description-content').toggleClass('collection__description-content--visible');
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Show More / Show Less Toggle for Hidden Description (Used in text.liquid)
$(document).ready(function () {
  const toggleButton = document.querySelector('.js-toggle-button');
  const buttonTextSpan = toggleButton ? toggleButton.querySelector('span') : null;
  const description = document.querySelector('.text__description--hidden');
  const image = document.querySelector('.seo-text__bg-image'); // Optional image fade

  if (!toggleButton || !description || !buttonTextSpan) return;

  toggleButton.addEventListener('click', function () {
    const isExpanded = description.classList.contains('expanded');

    if (!isExpanded) {
      // Expand
      description.classList.add('expanded');
      description.style.maxHeight = description.scrollHeight + 'px';

      if (image) {
        image.style.transition = 'opacity 0.5s ease-out';
        image.style.opacity = '1';
      }

      buttonTextSpan.textContent = 'Show Less';
      toggleButton.style.paddingTop = '20px'; // Add padding when expanded
    } else {
      // Collapse: set maxHeight to current height before collapsing
      description.style.maxHeight = description.scrollHeight + 'px';

      requestAnimationFrame(() => {
        description.style.maxHeight = '0';
        description.classList.remove('expanded');

        if (image) {
          image.style.opacity = '0';
        }

        buttonTextSpan.textContent = 'Show More';
        toggleButton.style.paddingTop = ''; // Remove extra padding when collapsed
      });
    }
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'flex').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});
// Keyboard interaction - only open on Enter
$(".nav__dropdown .nav__link").on("keydown", function (e) {
  if (e.key === "Enter") {
    const $submenu = $(this).closest(".nav__dropdown").children(".nav__sub-menu");
    if ($submenu.is(":visible")) {
      $submenu.stop(true, true).fadeOut(); // Close if already open
      $('.nav-overlay').stop(true, true).fadeOut();
    } else {
      $submenu.stop(true, true).fadeIn(); // Open if closed
      $('.nav-overlay').stop(true, true).fadeIn();
    }
    e.preventDefault(); // Prevent default Enter behavior
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Zip
$('.product-finance__link--zip').on('click', function () {
  $('.product-finance-popup--zip').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 

  // Featured Collection - Tabs
  $('.featured-collection-tabs__tab').off('click').on('click', function () {
    var tab = $(this).data('tab');
    $('.featured-collection-tabs__tab').removeClass('featured-collection-tabs__tab--active');
    $('.featured-collection-tabs__tab-content').removeClass('featured-collection-tabs__tab-content--active');
    $(this).addClass('featured-collection-tabs__tab--active');
    $('#' + tab).addClass('featured-collection-tabs__tab-content--active');
  });         
    
  // Clone
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-announcements').toggleClass('header-announcements--hide');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-announcements').removeClass('header-announcements--hide');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
    }
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      console.log(dataid);
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Swatches
function initSwatches() {
  if (window.swatches != undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');

    if ($(window).width() > 599) {
      $('.swatches__col').hover(
        function () {
          if ($(this).closest('[data-group-col]').length > 0) {
            let _id = $(this).data('product-id');
            let _h = window.swatches.filter(function (e) { return (e.id == _id) });
            if (_h.length > 0) {
              showSwatchData(this, _h[0]);
            }
            else {
              //swatch data not exist - need get firstly
              let el = this;
              var _handle;
              if (productsForFilter.length == 0) {
                _handle = $(this).attr('href').replace('/products/', '');
              }
              else {
                _handle = productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/' + _id))[0].handle;
              }
              if (_handle != undefined) {
                getSwatchData(_handle, function (h) {
                  showSwatchData(el, this);
                });
              }
            }
          }
        }, function () {
          if ($(this).closest('[data-group-col]').length > 0) {
            let _id = $(this).parent().find("[class*='--current']").closest('a').data('product-id');
            let _h = window.swatches.filter(function (e) { return (e.id == _id) });
            if (_h.length > 0) {
              showSwatchData(this, _h[0]);
            }
            else if (_id != undefined) {
              //swatch data not exist - need get firstly
              const el = this;
              var _handle = productsForFilter.filter(item => item.id === _id)[0].handle;
              if (_handle != undefined) {
                getSwatchData(_handle, function (h) {
                  showSwatchData(el, this);
                });
              }
            }
          }
        }
      );
    }
    else {
      $('.swatches__col').on('click', function (e) {
        if ($(this).closest('[data-group-col]').length > 0) {
          if ($('div', this).hasClass('swatches__swatch--current')) return true;
          e.preventDefault();
          $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
          $('div', this).addClass('swatches__swatch--current');
          const _id = $(this).data('product-id');
          const _h = window.swatches.filter(function (e) { return (e.id == _id) });
          if (_h.length > 0) {
            showSwatchData(this, _h[0]);
          }
          else {
            //swatch data not exist - need get firstly
            const el = this;
            var _handle;
            if (productsForFilter.length == 0) {
              _handle = $(this).attr('href').replace('/products/', '');
            }
            else {
              _handle = productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/' + _id))[0].handle;
            }
            if (_handle != undefined) {
              getSwatchData(_handle, function (h) {
                showSwatchData(el, this);
              });
            }
          }
          return false;
        }
      });

    }

  }
}

function getSwatchData(_handle, callback) {
  $.ajax({
    method: 'GET',
    url: document.location.origin + "/products/" + _handle + "/?view=swatch",
    success: function (data) {
      var _d = data.replace(/\n/g, '').replace(/,}/g, '}');
      window.swatches = window.swatches || [];
      const h = JSON.parse(_d);
      window.swatches.push(h);
      callback.apply(h);
    }
  });
}
function showSwatchData(el, h) {
  var item = $(el).closest('.product-card');
  item.find('.product-card__image').attr("src", h.image);
  item.find('.product-card__image').attr("srcset", "");
  item.find('.product-card__title').text(h.title);
  item.find('.product-card__sku span').text(h.sku);
  item.find('.product-card__price-current').text(h.price);
  item.find('.product-card__price').removeClass('product-card__price--on-sale');
  item.find('.product-card__price').addClass(h.onsale);
  item.find('.product-card__price-compare').text(h.pricecompare);
  item.find('.product-card__price-saving').html(h.saving);
  item.find('.product-card__overlays').replaceWith(h.overlays);
}

// Run Functions
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x=> {
    if (x.evt && !$(x.el).is(document)) {
      if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
        $(x.el).off(x.evt+'.'+x.f)
          if (typeof(x.f)=='function') {
            setTimeout(x.f,0);
          }
        else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
    }
    else {
      if (typeof(x.f)=='function') {
        setTimeout(x.f,0);
      }
      else {
       window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
    }  
  });
  if (window.afterLoadWithEvents.length==0) {
    $(window).off('scroll.afterLoad');
  }
}

function loadswatches(ismissed) {
  if (ismissed !== true) {
    //product detail group swatch    
    $('[data-group]').each(function () {
      let el = $(this);
      let tags = [];
      const t = 'Product Group Code|' + $(el).data('group');
      tags.push(t);
      renderSwatchAndOverlay(tags, function () {
        let _html = '';
        let swatchItems=_productsData.filter(p => p.GroupCode == $(el).data('group'));
        const productId=$('[name$="product-id"]').val();
        swatchItems=swatchItems.sort((a, b) => {
            if (a.id == productId) return -1;
            if (b.id == productId) return 1;
            return 0;  
          });
        swatchItems.forEach(p => {
          _html += _swatchSettings.item.replace('{{id}}', p.id).replace('{{url}}', p.handle).replace('{{color}}', p.swatchColor).replace('{{colorSecondary}}', p.swatchColorSecondary).replaceAll('{{name}}', p.swatchName).replace('{{current}}', '').replace('{{colcurrent}}', '');
        });
        if (swatchItems.length>10) {
          $('.product-swatches').addClass('product-swatches__toggle');
          _html +=`<div class="swatches__col" data-swatches-more>
                    <div class="swatches__swatch-more">
                      <span class="swatches__swatch-count">+${swatchItems.length-10} more</span>
                      <span class="swatches__swatch-view">View All <i class="fa far-angle-down"></i></span>
                      <span class="swatches__swatch-view" style="display: none;">View Less <i class="fa far-angle-up"></i></span>
                    </div>
                  </div>`;             
        }
        el.empty().append(_html);
          if (swatchItems.length>10) {
            $('.swatches__swatch-more').off('click').on('click', function () {
            $('.product-swatches__toggle').toggleClass('product-swatches__toggle--visible');
            $('.swatches__swatch-view').toggle();
            return false;
          });
        }
        $('[data-group]').find('[href="' + document.location.pathname + '"] .swatches__swatch').addClass('swatches__swatch--current');
      });
    });
  }
  let sEl = $('[data-group-col]');
  if (ismissed !== true) {
    sEl = $('[data-group-col]:not(:has(.swatches__col))');
  }
  if (sEl.length > 0) {
    let tags = [];
    sEl.each(function () {
      const t = 'Product Group Code|' + $(this).data('group-col');
      if (!tags.includes(t)) tags.push(t);
    });
    renderSwatchAndOverlay(tags, function () {
      sEl.each(function () {
        let overlayHtml = '';
        let htmlItems = [];
        let _tag = $(this).data('group-col');
        let _productsForTag = _productsForTags.filter(p => p.tag == _tag);
        let _id = $(this).data('group-col-id');
        if (_productsForTag.length == 0) {
          _productsForTags.push({
            tag: _tag,
            products: _productsData.filter(p => p.GroupCode == _tag)
          });
          _productsForTag = _productsForTags.filter(p => p.tag == _tag);
        }
        if (_productsForTag.length > 0) {
          if (_productsForTag[0].products.length == 0) _productsForTag[0].products=_productsData.filter(p => p.GroupCode == _tag);
          _productsForTag[0].products.sort((a, b) => {
            if (a.id == _id) return -1;  // current item goes first
            if (b.id == _id) return 1;   // current item goes first
            return 0;  // maintain original order for other items
          }).forEach(p => {
            let current = '';
            let colcurrent = '';
            if (_id == p.id) {
              current = "swatches__swatch--current";
              colcurrent = "swatches__col--current";
              overlayHtml = p.overlay;
            }
            htmlItems.push(_swatchSettings.item.replace('{{id}}', p.id).replace('{{url}}', p.handle).replace('{{color}}', p.swatchColor).replace('{{colorSecondary}}', p.swatchColorSecondary).replaceAll('{{name}}', p.swatchName).replace('{{current}}', current).replace('{{colcurrent}}', colcurrent));
          });
          let _html = $(_swatchSettings.template.replace('{{items}}', htmlItems.join('')));
          if (htmlItems.length > 4) {
            _html.append('<a class="product-card__swatch-more" href="' + $(this).closest('.product-card').find('.product-card__image-link').attr('href') + '">+'+(htmlItems.length-4)+'</a>');
          }
          _html.attr('data-group-col', _tag);
          _html.attr('data-group-col-id', _id);
          if (htmlItems.length >1)
          $(this).replaceWith(_html);
        }
      });
      window.swatches = [];
      initSwatches();
    });
  }
}

function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
}
  
$(document).ready(function(){
  register(); 
  loadswatches();
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// Load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc[0];
    sc.splice(0,1);   
    if (sc.length>0) {
      $(lc).on('load',function() {loadScript(sc,callback)});           ;
    }
    else if (callback!=undefined) {
    $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  } else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

var _productsData = [];
var _productsForTags = [];
var _swatchSettings = {
  template: '<div class="swatches product-card__swatches">{{items}}</div>',
  item: `<a class="swatches__col" data-product-id="{{id}}" href="/products/{{url}}" title="{{name}}">
<div class="swatches__swatch {{current}}">
  <span class="swatches__swatch-primary" style="background-color: {{color}}">
    <span class="swatches__swatch-secondary" style="background-color: {{colorSecondary}}"></span>
  </span>
</div>
<div class="swatches__tag">{{name}}</div>
</a>`,
  overlay: '<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>'
};
function renderSwatchAndOverlay(tags, callback,start) {
  if (tags.length > 0) {
    var tagsVar = "tag:'" + tags.join("' OR '") + "'";
    FetchDataWithVariables(`query($tagsVar: String){
      products( first: 250${start?`,after:"${start}"`:''},query:$tagsVar) {
        pageInfo {
          hasNextPage      
        }
        edges{
          cursor
          node {
            id
            handle
            title
            onlineStoreUrl
            tags
            images(first:2) {    
              edges {       
                node {
                  originalSrc     
                  id
                }
              }
            }
            metafields (identifiers: [ 
             {namespace: "general", key: "swatch_name"},
             {namespace: "general", key: "swatch_colour"},
             {namespace: "general", key: "swatch_colour_secondary"},             
            ]){           
              value
              key
              namespace
            }
            variants(first: 100) {
            edges {
              node {       
                price { amount }
                compareAtPrice { amount }
                availableForSale
                id                    
              }
            }
          }
        }
      }  
    }       
  }`, { tagsVar }, function (data) {
      //console.log(data);
      let lastcusros;
      let Products = data.data.products.edges;
      for (let p of Products) {
        if ((endpoint.includes('v2b1i1-4a') || p.node.onlineStoreUrl != null) && _productsData.filter(c => c.id == p.node.id.replace('gid://shopify/Product/', '')).length == 0) {
          let _product = {
            id: p.node.id.replace('gid://shopify/Product/', ''),
            handle: p.node.handle,
            title: p.node.title
          };
          _product.overlays = [];

          for (let mf of p.node.metafields) {
            if (mf != null && mf.key == 'swatch_name') _product.swatchName = mf.value;
            if (mf != null && mf.key == 'swatch_colour') _product.swatchColor = mf.value;
            if (mf != null && mf.key == 'swatch_colour_secondary') _product.swatchColorSecondary = mf.value;
          }
          p.node.tags.forEach(t => {
            if (t.startsWith("Product Group Code|")) _product.GroupCode = t.replace('Product Group Code|', '');
          });



          _product.images_info = [];
          for (let v of p.node.images.edges) {
            _product.images_info.push({
              id: v.node.id,
              src: v.node.originalSrc,
              width: 1000,
              height: 1500
            });
          }
          _product.variants = [];
          let allowSale = true;
          for (let v of p.node.variants.edges) {
            if (v.node.availableForSale === true) allowSale = true;
            _product.variants.push({
              id: v.node.id,
              price: parseFloat(v.node.price.amount) * Shopify.currency.rate,
              available: v.node.availableForSale,
              compare_at_price: v.node.compareAtPrice != null ? parseFloat(v.node.compareAtPrice.amount) * Shopify.currency.rate : null
            });
          }
          let minPriceVariant = _product.variants.sort((a, b) => a.price - b.price)[0];
          _product.compare_at_price_min = parseFloat(minPriceVariant.compare_at_price);
          _product.price_min = parseFloat(minPriceVariant.price);
          let _overlayHtml = _swatchSettings.overlay;
          let overlayItems = [];
          _product.overlays.forEach(o => {
            switch (o.key) {
              case 'top_left_overlay':
                _overlayHtml = _overlayHtml.replace('{{overlay}}', 'top-left');
                break;
              case 'top_right_overlay':
                _overlayHtml = _overlayHtml.replace('{{overlay}}', 'top-right');
                break;
              case 'bottom_overlay':
                _overlayHtml = _overlayHtml.replace('{{overlay}}', 'bottom');
                break;
              default:
                _overlayHtml = _overlayHtml.replace('{{overlay}}', '');
                break;
            }
            overlayItems.push(_overlayHtml.replace('{{message}}', o.value));
          });
          _product.overlay = overlayItems.join('');
          if (allowSale) {
            _productsData.push(_product);
          }
          if (p.cursor !=undefined) lastcusros=p.cursor;
        }
      }
      //console.log(_productsData);     
      if (data.data.products.pageInfo.hasNextPage && lastcusros!=undefined) {
        renderSwatchAndOverlay(tags, callback,lastcusros);
      }
      else {
        callback.apply();
      }
    });
  }
  else {
    callback.apply();
  }
}

document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__item-image',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Swiper Video play and pause
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){ 
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
    $this.addClass("swiper-" + index); 
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index); 
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if($this.hasClass('swiper--autoplay')) {
      $autoplay = { delay: 4000 };
    } else {
      $autoplay = "";
    }

    if($this.hasClass('swiper--snap')) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    if($this.find(".swiper-pagination").length) {
      $pagination = '.pagination-' + index;
    } else {
      $pagination = null;
    }
    if($this.find(".swiper-pagination--fraction").length) {
      $pagination_type = 'fraction';
    } else {
      $pagination_type = 'bullets';
    }

    if($this.find(".swiper-button-next").length) {
      $next = '.next-' + index;
    } else {
      $next = null;
    }

    if($this.find(".swiper-button-prev").length) {
      $prev = '.prev-' + index;
    } else {
      $prev = null;
    }    

    if($this.find(".swiper-scrollbar").length) {
      $scrollbar = '.scrollbar-' + index;
    } else {
      $scrollbar = null;
    }
    swiperInstances[index] = new Swiper(".swiper-" + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      navigation: {
        prevEl: $prev,  
        nextEl: $next, 
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      }
    });
    }
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    slidesPerView: 'auto',
    direction: 'vertical',
    watchSlidesProgress: true,
  });
  productImagesSwiper = new Swiper(".swiper--product-images", {
    pagination: {
      el: ".swiper-pagination--product-images",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

function _getWindowLocation() {
  for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], n = 0; n < t.length; n++) e.push(t.charAt(n));
  var i = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
    r = "",
    o = i.replace(/#.*$/, "");
  return o.split("?").length > 1 && (r = o.split("?")[1]).length > 0 && (r = "?" + r), { pathname: window.location.pathname, href: i, search: r };
}

// Show Loading Overlay
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}

// General Accordion
$('.faqs-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if ($(this).hasClass('active')) {
      $('.faqs-accordion__title').next().slideUp();
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
    } else {
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded', 'true');
    }
  }
});

// Product Accordion
$('.product-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if($(this).hasClass('active')) {
      $('.product-accordion__title').next().slideUp();
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').attr('aria-expanded','false');
    } else {
      $('.product-accordion__title').attr('aria-expanded','false');
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded','true');
    }
  }
});

// Cart Discount
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  if (cartId != '' )  {
    const _var={
      cartId:cartId,
      discountCodes:discountCode
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        _updateCartContent(discountCode!=''?true:false);
      }
    );
  }
}

document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});

document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    $('#discount').val('');
  });
});

// Product Page - Qty Buttons
$(document).ready(function () {
  $('.product-add__quantity-add').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    $input.val(currentVal + 1).change();
  });

  $('.product-add__quantity-minus').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    if (currentVal > 1) {
      $input.val(currentVal - 1).change();
    }
  });
});

// Hero Text Banner - Delayed Video (On mousemove)
var videoPlayer = document.getElementById('vbanner');
if(videoPlayer){
  window.afterLoadWithEvents.push(
  {
     f:'_loadVideo',
     evt:'mousemove',
     el: document
   }
  ); 
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll('video#vbanner source'),
    valVideo = document.querySelector('video#vbanner'),
    valDataSrc = 'data-src',
    valDataPoster = 'data-poster';

    if(window.innerWidth < 601 ) {
      valDataSrc = 'data-src-mobile';
      valDataPoster = 'data-poster-mobile';
    }

    for(var i = 0; i<valSources.length;i++) {
      valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function() {
      videoPlayer.play();
    });
  }
}

// Hero Text Banner - AutoPlay Video
var videoAuto = document.getElementById('vbannerauto');
if(videoAuto){
  // Video
  var valSources = document.querySelectorAll('video#vbannerauto source'),
  valVideo = document.querySelector('video#vbannerauto'),
  valDataSrc = 'data-src',
  valDataPoster = 'data-poster';

  if(window.innerWidth < 601 ) {
    valDataSrc = 'data-src-mobile';
    valDataPoster = 'data-poster-mobile';
  }

  for(var i = 0; i<valSources.length;i++) {
    valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function() {
    videoAuto.play();
  });
}